import requestContractType from "./requestContractType";

export default {
  namespaced: true,
  modules: {
    "request-contract-type": requestContractType,
  },
};
